import { edecideCnameDev, edecideCnameProd, edecideCnameTest, edecideSpaLocal } from "ApiEdecideEnvironments";
import {
  siveApiDev,
  siveApiLocal,
  siveApiProd,
  siveApiTest,
  siveCnameDev,
  siveCnameProd,
  siveCnameTest,
  siveSpaDev,
  siveSpaLocal,
  siveSpaProd,
  siveSpaTest,
} from "ApiSiveEnvironments";

export interface Environment {
  clientId: string;
  applicationIdUrl: string;
  tenantId: string;
  backendUrl: string;
  frontendUrl: string;
  edecideUrl: string;
  staticWebAppUrl: string;
  name: string;
  shortName: string;
}

const tenantId = "2cda5d11-f0ac-46b3-967d-af1b2e1bd01a";
const appInt = {
  clientId: "124be027-5fb9-4641-acff-436007175a86",
  applicationIdUrl: "https://sbb.onmicrosoft.com/int-sive-identity",
  tenantId,
};

const appProd = {
  clientId: "ea4f5739-ec35-474f-98ff-24b4be9d7389",
  applicationIdUrl: "https://sbb.onmicrosoft.com/sive-identity",
  tenantId,
};

const local: Environment = {
  ...appInt,
  backendUrl: siveApiLocal,
  frontendUrl: siveSpaLocal,
  edecideUrl: edecideSpaLocal,
  staticWebAppUrl: siveSpaLocal,
  name: "Localhost",
  shortName: "local",
};

const dev: Environment = {
  ...appInt,
  backendUrl: siveApiDev,
  frontendUrl: siveCnameDev,
  edecideUrl: edecideCnameDev,
  staticWebAppUrl: siveSpaDev,
  name: "Develop",
  shortName: "dev",
};

const test: Environment = {
  ...appInt,
  backendUrl: siveApiTest,
  frontendUrl: siveCnameTest,
  edecideUrl: edecideCnameTest,
  staticWebAppUrl: siveSpaTest,
  name: "Test",
  shortName: "test",
};

const prod: Environment = {
  ...appProd,
  backendUrl: siveApiProd,
  frontendUrl: siveCnameProd,
  edecideUrl: edecideCnameProd,
  staticWebAppUrl: siveSpaProd,
  name: "Production",
  shortName: "prod",
};

function stripProtocol(url: string) {
  return url.replace(/^https?:\/\//, "");
}

function matchEnv(env: Environment) {
  const origin = stripProtocol(window.location.origin);
  return origin == stripProtocol(env.frontendUrl) || origin == stripProtocol(env.staticWebAppUrl);
}

export let environment: Environment;
export let bannerEnvironment: string;
if (matchEnv(local)) {
  environment = local;
  bannerEnvironment = "dev";
} else if (matchEnv(dev)) {
  environment = dev;
  bannerEnvironment = "dev";
} else if (matchEnv(test)) {
  environment = test;
  bannerEnvironment = "test";
} else if (matchEnv(prod)) {
  environment = prod;
  bannerEnvironment = "prod";
} else {
  console.trace(`env: origin '${window.location.origin}' is unhandled, falling back to 'dev'`);
  environment = dev;
  bannerEnvironment = "dev";
}

export function getDisplayName() {
  switch (environment.name) {
    case "Localhost":
      return "Local";
    case "Develop":
      return "Dev";
    case "Test":
      return "Test";
    case "Production":
    default:
      // empty for prod.
      return "";
  }
}

export function getTooltip() {
  switch (environment.name) {
    case "Localhost":
      return "Lokale Entwicklungsumgebung";
    case "Develop":
      return "Entwicklungsumgebung";
    case "Test":
      return "Testumgebung";
    case "Production":
    default:
      return "";
  }
}

export function getApplicationName(name: string) {
  const envDisplayName = getDisplayName();
  return name + (envDisplayName ? ` (${envDisplayName})` : "");
}
